import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import RefreshIcon from "@mui/icons-material/Refresh";
import CloseIcon from "@mui/icons-material/Close";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import LanguageSelector from "../components/LanguageSelector";
import ThemeSelector from "../components/ThemeSelector";
import InstallAppButton from "../components/InstallAppButton";
import { AuthContext } from "../context/Auth/AuthContext";
import Checkbox from "@mui/material/Checkbox";
import { lerPrefTela, gravarPrefTela } from "../hooks/usePrefTela";

/*
 * Menu ⋮ da barra (sugestão do Jds 04/11): um item por linha, com ícone e
 * texto, como qualquer menu. Na tela de tickets entram também "Atualizar" e
 * "Finalizar" (antes uma linha inteira de botões acima da lista); o
 * TicketsManager escuta o evento "sabezap:tickets" e faz a ação.
 */
export const acaoTickets = (detail) => window.dispatchEvent(new CustomEvent("sabezap:tickets", { detail }));

export default function MaisOpcoes({ isFullscreen, toggleFullscreen, toggleTheme }) {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const { pathname } = useLocation();
  const [el, setEl] = useState(null);
  const [finEl, setFinEl] = useState(null);
  const naTelaDeTickets = pathname.startsWith("/tickets");
  const admin = user?.profile?.toUpperCase() === "ADMIN";
  const fechar = () => { setEl(null); setFinEl(null); };
  const [, refazer] = useState(0);
  const alternar = (nome) => { gravarPrefTela(nome, !lerPrefTela(nome)); refazer((n) => n + 1); };
  const opcaoTela = (nome, rotulo) => (
    <MenuItem key={nome} onClick={() => alternar(nome)} sx={{ py: 0.25 }}>
      <ListItemIcon><Checkbox edge="start" size="small" checked={lerPrefTela(nome)} tabIndex={-1} disableRipple sx={{ p: 0.5 }} /></ListItemIcon>
      <ListItemText>{rotulo}</ListItemText>
    </MenuItem>
  );

  return (
    <>
      <Tooltip title="Mais opções">
        <IconButton color="inherit" size="small" aria-label="Mais opções" onClick={(e) => setEl(e.currentTarget)}>
          <MoreVertIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={el}
        open={!!el}
        onClose={fechar}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{ sx: { minWidth: 230 } }}
      >
        {naTelaDeTickets && (
          <MenuItem onClick={() => { acaoTickets({ acao: "atualizar" }); fechar(); }}>
            <ListItemIcon><RefreshIcon fontSize="small" /></ListItemIcon>
            <ListItemText>Atualizar lista</ListItemText>
          </MenuItem>
        )}
        {naTelaDeTickets && admin && (
          <MenuItem onClick={(e) => setFinEl(e.currentTarget)}>
            <ListItemIcon><CloseIcon fontSize="small" /></ListItemIcon>
            <ListItemText>Finalizar tickets</ListItemText>
            <ChevronRightIcon fontSize="small" sx={{ ml: 1, color: "text.secondary" }} />
          </MenuItem>
        )}
        {naTelaDeTickets && <Divider />}
        {naTelaDeTickets && opcaoTela("filtroTags", "Filtro por tags")}
        {naTelaDeTickets && opcaoTela("filtrosLista", "Filtros da lista (Todos, Aberta…)")}
        {naTelaDeTickets && <Divider />}
        <MenuItem onClick={() => { toggleFullscreen(); fechar(); }}>
          <ListItemIcon>{isFullscreen ? <FullscreenExitIcon fontSize="small" /> : <FullscreenIcon fontSize="small" />}</ListItemIcon>
          <ListItemText>{isFullscreen ? t("mainDrawer.appBar.fullscreen.exit") : t("mainDrawer.appBar.fullscreen.enter")}</ListItemText>
        </MenuItem>
        <InstallAppButton comoItem aoEscolher={fechar} />
        <ThemeSelector comoItem toggleTheme={toggleTheme} aoEscolher={fechar} />
        <LanguageSelector comoItem aoEscolher={fechar} />
      </Menu>
      <Menu
        anchorEl={finEl}
        open={!!finEl}
        onClose={() => setFinEl(null)}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {["all", "open", "groups", "pending"].map((s) => (
          <MenuItem key={s} onClick={() => { acaoTickets({ acao: "finalizar", status: s }); fechar(); }}>
            {t(`ticketsManager.menu.${s}`)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
